const loGet = require('lodash/get');
const { set: setObjectPath, split, toPathArray, join } = require('@dbk-legacy/muster/utils');
const authNodes = ['globalAuthLoginVascoNewUI','verifyOTP', 'initiateResetPassword', 'getUserIdDetails', 'startRMSession', 'verifyResetCode', 'otpVerified', 'validateDeviceBiometric', 'globalAuthLoginVascoNewUIForLUX', 'updateActivationStatus'];
const checkVerifyOTPNode = ['verifyOTP'];
const authHeaderPath = 'mAuth';
const txTokenNodes = ['initializeTx', 'fetchTx', 'fetchWebTx', 'validateMultisignPayment', 'resumeMultisignPayment']
/**
 * Default get handler factory that defers all get requests to the falcor model
 *
 * @param {Falcor.Model} falcorModel Falcor model that handles the requests
 *
 * @returns {Muster.GetHandlerFunction} Muster get handler
 */

/*
*Parse and search Falcor Model for the node which contains the auth header.
*/

function isTokenNode(path, node){
  return path.some(v=> node.indexOf(v) !== -1)
}

function isAuthPath(path){
  if(path.includes(authHeaderPath)){
    return path[2];
  }else{
    return null;
  }
}

function getToken(obj, parse) {
  for (var k in obj) {
    if (typeof obj[k] === 'object' && obj[k] !== null) {
      getToken(obj[k], parse)
    } else if (obj.hasOwnProperty(k)) {
      parse(obj[k])
    }
  }
}


 function get(falcorModel) {
  return (requests) => {
    const paths =  requests.map(({ req }) => split(req.path));

    const authHeaderC = isAuthPath(...paths);
    if(authHeaderC){
      falcorModel._source._config.headers["Authorization-Token"] = authHeaderC; 
      paths.pop();
    }

  return falcorModel
    .get(...paths)
    .then((response) => {
      let result = loGet(response, 'json', {})

      //1. check if path contains auth code
      if(isTokenNode(...paths, authNodes)){
        //2. extract the auth header
        getToken(result, function(prop) { 
          if(prop){
            try {
              let authHeader;
              const authP = JSON.parse(prop);
              if(authP !== undefined && authP.hasOwnProperty("authHeader")){
                authHeader = authP.authHeader;
                falcorModel._source._config.headers["Authorization-Token"] = authHeader; 
              }else if(authP !== undefined && authP.hasOwnProperty("jwt")){
                authHeader = authP.jwt;
                if(authHeader === null && isTokenNode(...paths, checkVerifyOTPNode)){
                  return;
                }
                falcorModel._source._config.headers["Authorization-Token"] = authHeader;
              }
            } catch (e) {
              console.log("json parse error: "+e);
            }
          }
        })
        return result;
      }

      //1. check if path contains txtoken
      if(isTokenNode(...paths, txTokenNodes)){
        //2. extract the txtoken
        getToken(result, function(prop) { 
          if(prop){
            try {
              const authP = JSON.parse(prop);
              if(authP !== undefined && authP.hasOwnProperty("txToken")){
                const txToken = authP.txToken;
                falcorModel._source._config.headers["Transaction-Token"] = txToken; 
              }
            } catch (e) {
              console.log("json parse error: "+e);
            }
          }
        })
        return result;
      }
      
      return result;
      })
    .catch((maybeArray) => {
        if (Array.isArray(maybeArray)) {
          throw new Error(
            maybeArray.map((err) => `${err.value.message} at path \`${join(err.path)}\``).join('\n')
          );
        }
        throw new Error(maybeArray);
      })
    .then(toPathArray);
  };
}

/**
 * Default set handler factory that defers all set requests to the falcor model
 *
 * @param {Falcor.Model} falcorModel Falcor model that handles the requests
 *
 * @returns {Muster.SetHandlerFunction} Muster set handler
 */
function set(falcorModel) {
  return (requests) => {
    const envelope = {
      json: {},
    };

    requests.forEach(({ req }) => {
      setObjectPath(envelope.json, `${req.path}`, req.value);
    });

    return falcorModel
      .set(envelope)
      .then(() => requests.map(({ res }) => res.ok()));
  };
}

/**
 * Default call handler factory that defers all call requests into the falcor model
 *
 * @param {Falcor.Model} falcorModel Falcor model that handles the requests
 *
 * @returns {Muster.CallHandlerFunction} Muster call handler
 */
function call(falcorModel) {
  return ({ req }) => (
    falcorModel
      .call(req.path, req.args)
      .then((response) => loGet(response, 'json.jsonGraph', {}))
  );
}

/**
 * Create the default handlers for each of get, set and call with a single falcor model
 *
 * @param {Falcor.Model} falcorModel Falcor model that handles the requests
 *
 * @returns {Object} Handlers
 */
function createDefaultHandlers(falcorModel) {
  return {
    get: get(falcorModel),
    set: set(falcorModel),
    call: call(falcorModel),
  };
}

module.exports = {
  createDefaultHandlers,
  get,
  set,
  call,
};